// Browser-side config source. Vite only exposes VITE_-prefixed env vars to the
// client, so the browser honestly sees only the SAFE flags — server-held
// secrets never reach here. parseConfig is pure and platform-agnostic.
import { parseConfig, featureFlags, type RawEnv, type LifeOsConfig, type FeatureFlags } from '@life-os/app-core';

function browserEnv(): RawEnv {
  const env = import.meta.env as unknown as Record<string, string | undefined>;
  const raw: RawEnv = {};
  for (const [k, v] of Object.entries(env)) {
    if (typeof v === 'string') raw[k] = v;
  }
  return raw;
}

export const appConfig: LifeOsConfig = parseConfig(browserEnv());
export const appFlags: FeatureFlags = featureFlags(appConfig);
